import React, { useEffect } from "react";

const CommonInputField = ({
  label,
  name,
  required = false,
  register,
  errors,
  placeholder = "",
  defaultValue = "",
  setValue,
  readOnly = false,
  type = "text",
}) => {
  useEffect(() => {
    if (defaultValue && setValue) {
      setValue(name, defaultValue);
    }
  }, [defaultValue, name, setValue]);

  const isNumber = type === "number";

  return (
    <div className="flex flex-col gap-2">
      <label className="font-bold text-base" htmlFor={name}>
        {label}
        {required && <span className="text-red-500 text-xs ml-0.5">*</span>}
      </label>
      <input
        id={name}
        type={type}
        placeholder={placeholder}
        defaultValue={defaultValue}
        readOnly={readOnly}
        min={isNumber ? 0 : undefined}
        onKeyDown={(e) => {
          if (isNumber && (e.key === "-" || e.key === "e")) {
            e.preventDefault(); // Block "-" and "e" in number input
          }
        }}
        {...register(name)}
        className={`border rounded-lg px-[16px] py-[11px] outline-none transition-all focus:border-blue-300 focus:ring-2 focus:ring-blue-200 ${
          errors?.[name]
            ? "border-red-500 focus:border-red-300 focus:ring-red-200"
            : "border-gray-300"
        }`}
      />
      {errors[name] && (
        <p className="text-red-500 text-xs">{errors[name]?.message}</p>
      )}
    </div>
  );
};

export default CommonInputField;
